module.exports = "<mat-dialog-content>\n  <h1 mat-dialog-title>{{data.message}}</h1>\n</mat-dialog-content>\n<mat-dialog-actions>\n  <button mat-raised-button color=\"primary\" [mat-dialog-close]=\"true\">Yes</button>\n  <button mat-raised-button color=\"warn\" [mat-dialog-close]=\"false\">No</button>\n</mat-dialog-actions>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/common/dialog/confirmdialog.component.html
// module id = ../../../../../src/app/components/common/dialog/confirmdialog.component.html
// module chunks = main